import { Control, Controller } from 'react-hook-form'

import { PublicVisibilitySelector } from 'common/components/PublicVisibilitySelector'
import { PublicVisibility } from 'features/videos/service'

import { VideoMainFormValues } from '../../videoMainForm.types'

type Props = {
  control: Control<VideoMainFormValues>
}

export const PublicVisibilityController = ({ control }: Props) => {
  return (
    <Controller
      control={control}
      name={'publicVisibility'}
      rules={{ required: 'Выберите публичность видео' }}
      render={({ field, fieldState }) => (
        <PublicVisibilitySelector
          value={field.value as PublicVisibility}
          onChange={field.onChange}
          errorMessage={fieldState.error?.message}
        />
      )}
    />
  )
}
